import React, { useState, useCallback } from 'react'
import { Stack, Flex, Box, Heading, Text } from '@chakra-ui/react'
import type { BoxProps } from '@chakra-ui/react'
import { getTrendingCardRenderer } from '@/components/Card/Word'
import type { Glossary } from '@/types/glossary'
import { SectionContainer } from '@/components/SectionContainer'
import { SwiperRow } from '@/components/SwiperRow'
import { IconButton } from '@chakra-ui/react'
import { BsArrowLeft, BsArrowRight } from 'react-icons/bs'
import { useIsPhoneWidth } from '@/hooks/useIsMobile'
import { useIsTabletWidth } from '@/hooks/useIsTablet'
import { useTranslation } from 'react-i18next'

type TrendingSectionProps = BoxProps & {
  data: Glossary[]
}

export const TrendingSection = ({
  data,
  ...restProps
}: TrendingSectionProps) => {
  const { t } = useTranslation()
  const [activeIndex, setActiveIndex] = useState(0)
  const [selectedWord, setSelectedWord] = useState<Glossary | null>(null)
  const isPhone = useIsPhoneWidth()
  const isTablet = useIsTabletWidth()
  const swiperStep = isPhone ? 1 : isTablet ? 2 : 3

  const handleSlidePrev = () => {
    //if (activeIndex < swiperStep) return
    let nextIndex = activeIndex - swiperStep
    nextIndex =
      nextIndex < 0
        ? data.length -
          (data.length % swiperStep ? data.length % swiperStep : swiperStep)
        : nextIndex

    setActiveIndex(nextIndex)
  }

  const handleSlideNext = () => {
    //if (activeIndex + swiperStep >= MAX_INDEX) return
    let nextIndex = activeIndex + swiperStep
    nextIndex = nextIndex > data.length - 1 ? 0 : nextIndex
    setActiveIndex(nextIndex)
  }

  //const totalPage = Math.ceil(data.length / swiperStep)
  //const curPage = Math.floor(activeIndex / swiperStep) + 1

  return (
    <SectionContainer containerStyle={restProps}>
      <Flex
        flexDirection="column"
        alignItems="start"
        position={'relative'}
        overflow={'hidden'}
      >
        <Stack
          direction={['column', null, 'row', null]}
          spacing={4}
          alignItems={['flex-start', null, 'flex-end', null]}
        >
          <Heading variant={'h3'}>{t('homepage.trending')}</Heading>
        </Stack>
        <Box
          overflow={'hidden'}
          maxW={['100%', null, '720px', '1270.5px']}
          w={['100%', null, '720px', '1270.5px']}
          className={'trending-swiper-container'}
          mt={8}
        >
          <Flex flexDir={'column'}>
            <SwiperRow
              swiperStep={swiperStep}
              activeIndex={activeIndex}
              slides={data}
              selectedWord={selectedWord}
              setSelectedWord={setSelectedWord}
              renderer={getTrendingCardRenderer}
            />
          </Flex>
        </Box>
        <Box
          marginLeft={'auto'}
          position={'absolute'}
          right={['2%', null, null, '10%']}
          top={['85%', null, null, '90%']}
          zIndex={2}
        >
          <IconButton
            isDisabled={data.length > swiperStep ? false : true}
            aria-label="slide 3 prev cards"
            icon={<BsArrowLeft fontSize={'40px'} />}
            variant="unstyled"
            onClick={() => handleSlidePrev()}
          />

          <IconButton
            ml={12}
            isDisabled={data.length > swiperStep ? false : true}
            aria-label="slide 3 next cards"
            icon={<BsArrowRight fontSize={'40px'} />}
            variant="unstyled"
            onClick={() => handleSlideNext()}
          />
        </Box>
      </Flex>
    </SectionContainer>
  )
}
